import { render } from "./IconCopy.vue?vue&type=template&id=2123dea4"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCopy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2123dea4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2123dea4', __exports__)) {
    api.reload('2123dea4', __exports__)
  }
  
  module.hot.accept("./IconCopy.vue?vue&type=template&id=2123dea4", () => {
    api.rerender('2123dea4', render)
  })

}


export default __exports__